import { Feather, ShieldCheck, Smartphone, Zap } from "lucide-react";
import { site } from "../content/site";
import { Reveal } from "./Reveal";

const icons = { Feather, Zap, Smartphone, ShieldCheck };

export const ValueStrip = () => (
  <section className="bg-white" data-testid="value-strip" aria-label="Why people choose Banga Pay">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8">
      {site.valueStrip.map((item, i) => {
        const Icon = icons[item.icon];
        return (
          <Reveal key={item.title} delay={i * 0.08} className="flex gap-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-gray-200">
              <Icon className="h-5 w-5 text-brand" aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-gray-900">{item.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-gray-600">{item.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
